/** Edison 品牌 LOGO */
export const EDISON_LOGO_URL =
  'https://image.edison-car.com/lethe/img/20251209/298494eccb0c4236821b16fac8381700.jpg';
